import { AmbientOrbs } from '@/shared/ui/AmbientOrbs';
import { AuthForm } from './AuthForm';

export function Signup() {
  return (
    <div className="w-full max-w-md min-h-screen relative border-x border-white/5">
      <AmbientOrbs />
      <main className="min-h-screen flex flex-col items-stretch justify-center px-6 py-10">
        <AuthForm mode="signup" />
      </main>
    </div>
  );
}
